import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { usePaymentStore } from 'stores';
import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';
import CabinetBalanceInfoReference from 'shared/newComponents/CabinetBalanceInfoReference';
import { CircledQuestionIcon } from 'shared/newComponents/icons';
import { IconSize } from 'shared/entities/components/Icon';
import { urls } from 'shared/entities/domain';

import './CabinetBalance.modules.scss';

type Props = {
  className?: string;
};
const CabinetBalance: React.FC<Props> = ({ className }) => {
  const paymentStore = usePaymentStore();

  if (!paymentStore.info) {
    return null;
  }

  return (
    <div styleName="cabinet-balance" className={className}>
      <Link to={urls.SETTINGS.CABINET.BALANCE.create()}>
        <Typography
          fontType={TypographyType.text}
          fontSize={TypographySize.s}
          fontWeight={TypographyWeight.semiBold}
          fontColor={TypographyColor.blue}
        >
          {paymentStore.info.roundedBalanceString}
        </Typography>
      </Link>
      <CabinetBalanceInfoReference
        trigger={
          <div styleName="cabinet-balance__icon-wrapper">
            <CircledQuestionIcon
              styleName="cabinet-balance__icon"
              iconSize={IconSize.M}
            />
          </div>
        }
      />
    </div>
  );
};

export default observer(CabinetBalance);
